import React, {PureComponent}   from 'react';
import PropTypes                from 'prop-types';

const propTypes = {
  frameHeight         : PropTypes.string,
  frameWidth          : PropTypes.string,
  imgSize             : PropTypes.string,
  keepOriginalImgSize : PropTypes.bool,
  positionX           : PropTypes.string,
  positionY           : PropTypes.string,
  src                 : PropTypes.string,
};

const defaultProps = {
  frameHeight         : '100%',
  frameWidth          : '100%',
  imgSize             : 'cover',
  keepOriginalImgSize : false,
  positionX           : 'center',
  positionY           : 'center',
  src                 : null,
};

class ImageFit extends PureComponent {

  render() {
    const {
      frameHeight,
      frameWidth,
      imgSize,
      src,
      keepOriginalImgSize,
    } = this.props;

    let bgSize = imgSize;
    if (!(['cover', 'contain'].indexOf(bgSize) > -1)) {
      bgSize = 'cover';
    }
    if (keepOriginalImgSize) {
      bgSize = 'auto';
    }
    let positionX = this.props.positionX;
    if (!(['left', 'center', 'right'].indexOf(positionX) > -1)) {
      positionX = 'center';
    }
    let positionY = this.props.positionY;
    if (!(['top', 'center', 'bottom'].indexOf(positionY) > -1)) {
      positionY = 'center';
    }
    const style = {
      width              : frameWidth,
      height             : frameHeight,
      backgroundImage    : `url(${src})`,
      backgroundRepeat   : 'no-repeat',
      backgroundPosition : positionX + ' ' + positionY,
      backgroundSize     : bgSize,
    };
    return <div style={style} />;
  }

}

ImageFit.propTypes = propTypes;

ImageFit.defaultProps = defaultProps;

export default ImageFit;



// WEBPACK FOOTER //
// ./src/atoms/imageFit/ImageFit.js